import { render, staticRenderFns } from "./PageSecurityScriptsHistory.vue?vue&type=template&id=12c39cf0"
import script from "./PageSecurityScriptsHistory.vue?vue&type=script&lang=js"
export * from "./PageSecurityScriptsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports